var map = {
	"assets/images/relics/DRK/relic_weapon-g_w_anima-p_w_lux.png": 8551,
	"assets/images/relics/DRK/relic_weapon-g_w_eureka-p_w_pyros.png": 7257,
	"assets/images/relics/DRK/relic_weapon-g_w_resistance-p_w_blade.png": 8698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2255;